import React, { createContext } from 'react';
import PropTypes from 'prop-types';

const SMFooterContext = createContext({});

const { Provider } = SMFooterContext;

const FooterContext = props => (
  <Provider
    value={{
      ...props,
    }}
  >
    {props.children}
  </Provider>
);

FooterContext.propTypes = {
  children: PropTypes.node.isRequired,
};

export { SMFooterContext, FooterContext };
